function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChemical = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24pt",
    viewBox: "-29 0 24 24",
    height: "24pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.04164096
    },
    id: "path26",
    d: "M -19.716737,3.8359868 V 10.00926 l -0.77296,1.449463 0.230327,-0.09125 c 1.160578,-0.413319 2.245683,-0.213897 3.295004,-0.02099 0.961971,0.176649 1.870427,0.3437 2.786203,0.0205 l 0.500992,-0.183484 -0.626241,-1.174243 V 3.8359868 Z m 0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.04164096
    },
    id: "path28",
    d: "m -13.075654,12.311387 -0.68675,0.23358 c -0.530109,0.187058 -1.048832,0.253586 -1.549825,0.25375 -0.661213,0 -1.291683,-0.115978 -1.877747,-0.223658 -0.928301,-0.170631 -1.805201,-0.331664 -2.650383,-0.03057 l -1.506068,0.520345 -5.116146,9.592873 h 18.9049974 z m -3.354537,7.580119 -1.159767,-0.463906 0.739941,-1.850095 h -2.16533 l 1.425389,-3.56323 1.159767,0.463906 -0.739941,1.850096 h 2.165331 z m 0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0.04164096
    },
    id: "path30",
    d: "m -20.965966,1.3375291 h 7.911783 v 1.2492291 h -7.911783 z m 0,0"
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChemical, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chemical.01ce1b38.svg";
export { ForwardRef as ReactComponent };